import React from 'react';
import PropTypes from 'prop-types';
import Typeahead from 'react-bootstrap-typeahead';
import './AddressSearchTypeahead.scss';

const AddressSearchTypeahead = (props) => {
  const noAddressResults = 'Sorry, we didn\'t quite get that address. Please type it again so we can make sure we ' +
    'get the right place.';
  const placeholderText = 'Start typing your address';
  const minLength = 5;
  const { fetchAddressAutoComplete, isChange, storeStaticConfig } = props;
  const fetchAddressAutoCompleteWhenMinLengthMet = (text) => {
    if (text && text.length >= minLength) {
      fetchAddressAutoComplete(text);
    }
  };

  const fetchAddress = props.fetchAddress;
  const fetchAddressForSelectedAddress = (selectedAddresses) => {
    const selectedAddress = selectedAddresses[0];
    fetchAddress(selectedAddress, isChange);
    storeStaticConfig();
  };

  if (props.isAddressSelected || props.isError) {
    return null;
  }

  // TODO
  // 1. Fix the empty label rendering
  return (
    <Typeahead
      className="primary-address-search-typeahead autotest-primary-address-search-typeahead"
      options={props.addressAutoComplete}
      minLength={minLength}
      labelKey="label"
      emptyLabel={noAddressResults}
      onInputChange={fetchAddressAutoCompleteWhenMinLengthMet}
      onChange={fetchAddressForSelectedAddress}
      placeholder={placeholderText}
      filterBy={options => options}
      disabled={props.isLoading}
    />
  );
};

AddressSearchTypeahead.defaultProps = {
  isChange: false,
  isError: false,
  isLoading: true,
  isAddressSelected: false
};

AddressSearchTypeahead.propTypes = {
  addressAutoComplete: PropTypes.arrayOf(PropTypes.object).isRequired,
  fetchAddressAutoComplete: PropTypes.func.isRequired,
  fetchAddress: PropTypes.func.isRequired,
  storeStaticConfig: PropTypes.func.isRequired,
  isAddressSelected: PropTypes.bool,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  isChange: PropTypes.bool
};

export default AddressSearchTypeahead;



/** WEBPACK FOOTER **
 ** ./src/components/AddressSearch/AddressSearchTypeahead/AddressSearchTypeahead.js
 **/